import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { connect, useDispatch, useSelector } from 'react-redux';
import { frontloadConnect } from 'react-frontload';
import loadable from '@loadable/component';
import _ from 'lodash';
import { Redirect, useHistory, useLocation } from 'react-router-dom';
import ProductDetailMeta from './ProductDetailMeta';
import LocationSelector from './LocationSelector';
import ProductImages from './ProductImages';
import QuantityBox from './QuantityBox';
import QuantityInput from './QuantityInput';
import VariantSelector from './VariantSelector';
import useSWR from 'swr';

// import DealerInfo from '../../components/DealerInfo/DealerInfo';
import MoreProducts from '../../components/MoreProducts/MoreProducts';
import Meisterkachel from '../../components/Meisterkachel/Meisterkachel';
import BreadCrumbSelector from '../../components/BreadCrumb/BreadCrumbSelector';
import ReduxSuspense from '../../components/ReduxSuspense/ReduxSuspense';
import { productResponseSelector } from '../../../modules/selectors/standort/vehicleFilter/product';
import { fetchProductIfNeeded, setProductVariantId } from '../../../modules/actions/standort/product';
import { ExternalLink } from '../../components/form-elements/Link';
import withStandortRouter from '../../components/VHost/withStandortRouter';
import { standortUrlSelector } from '../../../modules/selectors/url';
import { addProduct, deleteOneClickCart, removeProduct, validateArticleBeforePaypalOneClick, validateCartBeforeCheckout } from '../../../modules/actions/standort/session/cart';
import TireInformationModal from '../../components/Tires/TireInformationModal';
import TireEnergyLabelLinks from '../Tires/TireEnergyLabelLinks';
import { datECodePrefixSelector } from '../../../modules/selectors/vehicle';
import { markenStandortSelector } from '../../../modules/selectors/standort/markenStandort';
import Status from '../../components/Status/Status';
import StandortRedirect from '../../components/VHost/StandortRedirect';
import { toast } from '../../../helpers/toastHelper';
import Spinner from '../../components/Spinner/Spinner';
import { saveproduct, resetproduct } from '../../../modules/actions/productID';
import Button from '../../components/form-elements/Button';
import { trackDataLayer, trackEvent, trackPDSCheckoutStart } from '../../components/Tracking/Matomo';
import { getActiveSalesPrice } from '../../../helpers/productHelper';
import { apiClient, useAsyncFunction } from '../../../helpers/apiHelperV2';
import classnames from 'classnames';
import SubLocationFinder from '../../components/SubLocationFinder/SubLocationFinder';
import { trackPinterestEvent } from '../../components/Tracking/Pinterest';
import DeliveryCountdown from './DeliveryCountdown';
import { Offcanvas } from '../../components/Offcanvas/Offcanvas';
import Image from '../../components/Image/Image';
import Currency from '../../../helpers/currency';
import InlineSpinner from '../../components/Spinner/InlineSpinner';
import MoreProductsSlider from './MoreProductsSlider';
import MoreProductsSliderCard from './MoreProductsSliderCard';
import { InternalLink } from '../../components/form-elements/Link';
import { markenStandortThemeHeaderSelector } from '../../../modules/selectors/standort/theme';
import useWindowSize from '../../../helpers/windowHelper';
import FAQs from '../../components/FAQs/FAQs';
import { createPayPalOrder } from '../../../helpers/CheckoutHelper';
import { get, has } from 'lodash';
import { sessionIdSelector, userSelector } from '../../../modules/selectors/auth';
import { PayPalButtons, PayPalMessages } from '@paypal/react-paypal-js';
import RedirectCheck from '../../../helpers/getRiderectsHelper';
import { redirectsResponseSelector, redirectsSelector } from '../../../modules/selectors/redirects';
import { findRedirectMatch } from '../../../helpers/redirectMatcher';
import NotFound from '../ErrorPages/NotFound/NotFound';
const ServiceStationFinder = loadable(() => import('../../components/ServiceStationFinder/ServiceStationFinder'));

const BREAKPOINT_LARGE = 1200;
// must be in sync with $breakpoint-medium
const BREAKPOINT_MEDIUM = 960;
// must be in sync with $breakpoint-small
const BREAKPOINT_SMALL = 640;

function ProductDetail({ product, categoryUrl, productUrl, isExact }) {
    const { selectedVariantId } = product;
    const headline = useRef(null);

    const dispatch = useDispatch();
    const markenStandort = useSelector(markenStandortSelector);
    const standortUrl = useSelector(standortUrlSelector);
    const datECodePrefix = useSelector(datECodePrefixSelector);
    const history = useHistory();

    const [plz, setPlz] = useState('');
    const [showMap, setShowMap] = useState(false);
    const serviceStationFinderRef = useRef(null);
    const [selectedQuantityBox, setSelectedQuantityBox] = useState(product.selectedLieferweg);
    const [quantityValue, setQuantityValue] = useState(1);
    const [isSidebarVisible, setSidebarVisible] = useState(false);
    const focusBtnRef = useRef();

    const sessionId = useSelector(sessionIdSelector)

    const [paypalOneClickSessionId, setPaypalOneClickSessionId] = useState(null)
    const [offsetTop, setOffsetTop] = useState(60);
    const couponBannerHeight = useSelector(state => state.couponHeight)
    const markenStandortThemeHeader = useSelector(markenStandortThemeHeaderSelector);
    const { width } = useWindowSize();
    const existingUser = useSelector(userSelector)

    useEffect(() => {
        const height = markenStandortThemeHeader.height;

        if (!height) {
            return;
        }

        if (width >= BREAKPOINT_LARGE) {
            setOffsetTop(couponBannerHeight != null ? height.large + couponBannerHeight.data + 60 : height.large + 60);
        } else if (width >= BREAKPOINT_MEDIUM) {
            setOffsetTop(couponBannerHeight != null ? height.medium + couponBannerHeight.data + 60 : height.medium + 60);
        } else if (width >= BREAKPOINT_SMALL) {
            setOffsetTop(height.small);
        } else {
            setOffsetTop(height.fallback);
        }
    }, [couponBannerHeight, markenStandortThemeHeader, width]);

    const topSellerResponse = useAsyncFunction(async () => apiClient.get(`/api/v1/standorte/${standortUrl}/bestseller`), [standortUrl]);

    let handlePress = (e) => {
        e.preventDefault()
        if (e.key === "Enter") {
            closeSidebar()
        }
    }

    const closeSidebar = useCallback(() => {
        setSidebarVisible(false);
    }, []);

    const variant = useMemo(() => {
        if (!_.isEmpty(product.varianten)) {
            return product.varianten.find(v => v._id === selectedVariantId) || product.varianten[0];
        }
        return undefined;
    }, [product, selectedVariantId]);

    if (variant.marketingText.includes('https://media0.autoteileplusservice.de')) {
        variant.marketingText = variant.marketingText.replace('https://media0.autoteileplusservice.de', 'https://techno-images.s3.eu-central-1.amazonaws.com')
    }

    const soldOut = useMemo(() => {
        if (!variant) return false;

        return (
            (variant.isOwnArticle && variant.stockkeeping && variant.stock < 1 && variant.stock !== null) ||
            (!variant.isOwnArticle && variant.stock < 1) ||
            variant.soldOut
        );
    }, [variant]);


    const deliveryTime = useMemo(() => {
        if (!variant) return false;

        const { deliveryDaysFrom, deliveryDaysTo } = variant;

        if (deliveryDaysFrom > 0 && deliveryDaysTo > 0) {
            return `${deliveryDaysFrom}-${deliveryDaysTo} Werktage`;
        }

        if (deliveryDaysFrom === 1) {
            return `${deliveryDaysFrom} Werktag`;
        } else if (deliveryDaysFrom > 0) {
            return `${deliveryDaysFrom} Werktage`;
        }


        if (deliveryDaysTo === 1) {
            return `${deliveryDaysTo} Werktag`;
        } else if (deliveryDaysTo > 0) {
            return `${deliveryDaysTo} Werktage`;
        }

        return '3-5 Werktage';

    }, [variant]);

    const pickupTime = useMemo(() => {
        if (!variant) return false;

        const { pickupDaysFrom, pickupDaysTo } = variant;

        if (pickupDaysFrom > 0 && pickupDaysTo > 0) {
            return `${pickupDaysFrom}-${pickupDaysTo} Werktagen`;
        }

        if (pickupDaysFrom === 1) {
            return `${pickupDaysFrom} Werktag`;
        } else if (pickupDaysFrom > 0) {
            return `${pickupDaysFrom} Werktagen`;
        }

        if (pickupDaysTo === 1) {
            return `${pickupDaysTo} Werktag`;
        } else if (pickupDaysTo > 0) {
            return `${pickupDaysTo} Werktagen`;
        }

        return '3-5 Werktagen';

    }, [variant]);

    useEffect(() => {
        if (isSidebarVisible && focusBtnRef.current) {
            focusBtnRef.current.focus();
            window.scrollTo({ top: 0, behavior: 'smooth' });
        }
    }, [isSidebarVisible]);

    const setVariantId = useCallback(
        variantId =>
            dispatch(
                setProductVariantId({
                    standortUrl,
                    datECodePrefix,
                    categoryUrl,
                    productUrl,
                    variantId,
                })
            ),
        [categoryUrl, datECodePrefix, dispatch, productUrl, standortUrl]
    );

    useEffect(() => {
        if (showMap) {
            // TODO: refactor scroll centering of freshly mounted child DOM nodes
            serviceStationFinderRef.current?.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
    }, [showMap]);

    useEffect(() => {
        if (variant) {
            let productID;
            if (variant.isOwnArticle) {
                productID = variant.shownId || variant._id;
            } else {
                productID = variant.id;
            }
            dispatch(saveproduct(productID));
        }
    }, [dispatch, variant]);

    useEffect(() => {
        const unlisten = history.listen((location, action) => {
            dispatch(resetproduct());
        });

        return unlisten;
    }, [dispatch, history]);


    useEffect(() => {
        if (standortUrl === "gottfried-schultz") {
            const script = document.createElement('script');
            script.src = '//cdn.doofinder.com/recommendations/js/doofinderRecommendation.min.js';
            script.async = true;
            document.body.appendChild(script);
            return () => {
                document.body.removeChild(script);
            };
        }

        if (headline.current) {
            headline.current.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        }
        trackDataLayer({
            eventName:"view_product", 
            products:[variant], 
            standort: markenStandort,
            value: getActiveSalesPrice(variant),
            isOnline: selectedQuantityBox.legalType === 'online-kauf'
        })

    }, [markenStandort, selectedQuantityBox.legalType, standortUrl, variant])
  
    useEffect(() => {
        const isOwnArticle = product?.isOwnArticle || variant?.isOwnArticle;
        const ownArticleId = variant?._id;
        if (!standortUrl || !isOwnArticle || !ownArticleId) {
            return;
        }

        apiClient
            .post(`/api/v1/standorte/${standortUrl}/ownArticlePageViews`, {
                ownArticleId,
                shownId: variant?.shownId || product?.shownId,
            })
            .catch(err => {
                console.error('Failed to track own article page view', err);
            });
    }, [standortUrl, product?.isOwnArticle, product?.shownId, variant?.isOwnArticle, variant?._id, variant?.shownId]); 

    function getDeliveryAddress(paypalAuthorize) {
        const lastName = get(paypalAuthorize, 'purchase_units[0].shipping.name.full_name', '').split(' ').slice(-1).pop();
        const country = has(paypalAuthorize, 'purchase_units[0].shipping.address.country_code')
            ? get(paypalAuthorize, 'purchase_units[0].shipping.address.country_code', '')
            : get(paypalAuthorize, 'payer.name.address.country_code', '');
    
        if (country !== 'DE') {
            throw new Error('Bestellungen außerhalb Deutschlands werden nicht unterstützt.');
        }
    
        return {
            city: has(paypalAuthorize, 'purchase_units[0].shipping.address.admin_area_2')
                ? get(paypalAuthorize, 'purchase_units[0].shipping.address.admin_area_2', '')
                : get(paypalAuthorize, 'payer.name.address.admin_area_2', ''),
            zipCode: has(paypalAuthorize, 'purchase_units[0].shipping.address.postal_code')
                ? get(paypalAuthorize, 'purchase_units[0].shipping.address.postal_code', '')
                : get(paypalAuthorize, 'payer.name.address.postal_code', ''),
            street: has(paypalAuthorize, 'purchase_units[0].shipping.address.address_line_1')
                ? get(paypalAuthorize, 'purchase_units[0].shipping.address.address_line_1', '')
                : get(paypalAuthorize, 'payer.name.address.address_line_1', ''),
            additionalAddressInfo: has(paypalAuthorize, 'purchase_units[0].shipping.address.address_line_2')
                ? get(paypalAuthorize, 'purchase_units[0].shipping.address.address_line_2', '')
                : get(paypalAuthorize, 'payer.name.address.address_line_2', ''),
            country: 'Deutschland',
            lastName: lastName,
            firstName: get(paypalAuthorize, 'purchase_units[0].shipping.name.full_name', '').split(lastName).join('').trim(),
        };
    }
    
    function getInvoiceAddress(paypalAuthorize) {
        const country = has(paypalAuthorize, 'payer.name.address.country_code')
            ? get(paypalAuthorize, 'payer.name.address.country_code', '')
            : get(paypalAuthorize, 'purchase_units[0].shipping.address.country_code', '');
    
        if (country !== 'DE') {
            throw new Error('Bestellungen außerhalb Deutschlands werden nicht unterstützt.');
        }
    
        return {
            city: has(paypalAuthorize, 'payer.name.address.admin_area_2')
                ? get(paypalAuthorize, 'payer.name.address.admin_area_2', '')
                : get(paypalAuthorize, 'purchase_units[0].shipping.address.admin_area_2', ''),
            zipCode: has(paypalAuthorize, 'payer.name.address.postal_code')
                ? get(paypalAuthorize, 'payer.name.address.postal_code', '')
                : get(paypalAuthorize, 'purchase_units[0].shipping.address.postal_code', ''),
            street: has(paypalAuthorize, 'payer.name.address.address_line_1')
                ? get(paypalAuthorize, 'payer.name.address.address_line_1', '')
                : get(paypalAuthorize, 'purchase_units[0].shipping.address.address_line_1', ''),
            additionalAddressInfo: has(paypalAuthorize, 'payer.name.address.address_line_2')
                ? get(paypalAuthorize, 'payer.name.address.address_line_2', '')
                : get(paypalAuthorize, 'purchase_units[0].shipping.address.address_line_2', ''),
            country: 'Deutschland',
            lastName: get(paypalAuthorize, 'payer.name.surname', ''),
            firstName: get(paypalAuthorize, 'payer.name.given_name', ''),
            payerId: get(paypalAuthorize, 'payer.payer_id', ''),
        };
    }

    let createOrder = async(data, actions) => {
        return await dispatch(addProduct({product: { ...variant, selectedLieferweg: selectedQuantityBox, deliveryDays: selectedQuantityBox.legalType === 'online-kauf' ? deliveryTime : pickupTime, deliveryText: selectedQuantityBox.legalType === 'online-kauf' ? `Lieferzeit: ${deliveryTime}` : `Abholbereit in: ${pickupTime}` }, quantity: quantityValue, buttonType:"paypalOneClick", paypalOneClickSessionId })).then(async result => {
            if(!result?.error && result?.data){
                trackPDSCheckoutStart({ legalType: 'online-kauf-pds' });
                trackDataLayer({
                    eventName:"begin_checkout", 
                    products:[Object.assign(variant,{quantity: quantityValue})], 
                    standort: markenStandort, 
                    value: getActiveSalesPrice(variant) * quantityValue,
                    isOnline: selectedQuantityBox.legalType === 'online-kauf'
                })
                trackPinterestEvent('checkout', {
                    legalType: 'online-kauf',
                });
                return actions.order.create(createPayPalOrder({ cart: result.data, hasNoShipping: false  }));
            }
        })
    }
    
    async function approveOrder(data, actions) {
        try {

            const paymentDetails = await actions.order.get();

            let cart = await apiClient.get(`/api/v1/standorte/${standortUrl}/carts/${paypalOneClickSessionId}`).then(result => {
                return result.data.data
            });

            const deliveryAddress = getDeliveryAddress(paymentDetails);
            const invoiceAddress = getInvoiceAddress(paymentDetails);

            const { data: user } = await apiClient.post('/api/v1/checkout/paypal/user', {
                existingUser,
                userData: paymentDetails,
                standortUrl,
            });
            let checkoutData = {
                payment: {
                    paymentDetails: paymentDetails,
                    paymentProvider: 'PayPal',
                    completed: true,
                },
                cart: {
                    ...cart,
                    products: cart.products.map(p => {
                        return {
                            ...p,
                            selectedLieferweg: {
                                ...(p.selectedLieferweg || {}),
                                type: 'paypalVersand',
                                paymentType: 'paypalVersand',
                            },
                        };
                    }),
                },
                userdata: {
                    deliveryAddress,
                    invoiceAddress,
                    infoEmail: get(paymentDetails, 'payer.email_address', ''),
                    completed: true,
                },
                user: user.data._id,
            };

            await apiClient.post('/api/v1/checkout/InitializePaypalCheckout', {
                products: cart.products,
                cart,
                standortUrl,
                selectedSublocation: null,
                type: 'online-kauf',
                sessionId: cart.sessionId,
                checkoutData,
            });

            const { data: nextUrl } = await apiClient.post('/api/v1/getNextCheckoutUrl/adresse', {
                sessionId: cart.sessionId,
            });

            if (nextUrl.data.redirectUrl) history.push(nextUrl.data.redirectUrl);
        } catch (err) {
            setPaypalOneClickSessionId(sessionId + "-paypalOneClick-" + Date.now())
            toast({ err, message: 'Fehler beim Abschicken der Bestellung, bitte wenden Sie sich an den Support.' });
        } finally {
            // setLoading(false);
        }
    }

     async function onError(err) {
        setPaypalOneClickSessionId(sessionId + "-paypalOneClick-" + Date.now())
        await dispatch(deleteOneClickCart({paypalOneClickSessionId}))
        toast({ err, message: 'Fehler beim Abschicken der Bestellung' });
    }

    async function onCancel(data) {
        setPaypalOneClickSessionId(sessionId + "-paypalOneClick-" + Date.now())
        await dispatch(deleteOneClickCart({paypalOneClickSessionId}))
    }

    function onClick(data, actions) {
        if (soldOut || variant?.deleted) {
            toast({
                message: 'Das gewählte Produkt ist aktuell nicht verfügbar.',
                status: 'warning',
            });
            return actions.reject();
        }

        return dispatch(
            validateArticleBeforePaypalOneClick({ article: variant, categoryUrl })
        ).then(isValid => {
            if (!isValid) {
                return actions.reject();
            }
        });
    }

    if (product.redirect) {
        toast({ message: product.redirect.message, status: 'warning' });
        return <StandortRedirect to={`/${categoryUrl}`} />;
    }
    const isFreeShipping = useMemo(() => {
        let isFreeShipping = variant.freeShipping || variant.shippingCostPerArticle === 0;
        let activeSalePrice = getActiveSalesPrice(variant);
        let freeShippingThreshold = product.selectedLieferweg?.versandkosten?.freiAb;

        return isFreeShipping || activeSalePrice >= freeShippingThreshold

    }, [product.selectedLieferweg?.versandkosten?.freiAb, variant]);

    const { data: seitenTexteResponse } = useSWR(`/api/v1/SeitenTexte?standortUrl=${markenStandort.url}`, async url => {
        const { data } = await apiClient.get(url);
        return data;
    });

    useEffect(() => {
        setPaypalOneClickSessionId(sessionId + "-paypalOneClick-" + Date.now())
    },[sessionId])

    const seitenTexte = useMemo(() => seitenTexteResponse?.body ?? [], [seitenTexteResponse]);
    const textBatterie = (seitenTexte && seitenTexte.find(text => text.name === 'Batterie')) || undefined;
    const textAltöl = (seitenTexte && seitenTexte.find(text => text.name === 'Altöl')) || undefined;


    if (_.isEmpty(product.varianten) || !variant) {
        // Invalid state
        return (
            <Status code={500}>
                <section className="uk-section uk-section-default uk-section-small">
                    <div className="uk-container" data-uk-margin="">
                        Es ist ein Fehler aufgetreten, bitte versuchen Sie es später erneut.
                    </div>
                </section>
            </Status>
        );
    }

    //const vorteile = product.selectedLieferweg?.Vorteilskommunikation ?? [];
    const additionalCrumbs = [
        {
            label: product.isOwnArticle ? variant.slug ?? 'Artikel' : variant.slug ?? product.id,
            key: categoryUrl
        },
    ];
    // const isOil = product.kennzeichnung === 'O' || variant.dangerous === 'oil' || variant.articleType === 'öl';
    const isBattery = variant.dangerous === 'battery' || variant.articleType === 'batterie';
    const isAB = variant.abcKategorie === "A" || variant.abcKategorie === "B";
    const isOfferActive = (variant.isDeliveryOfferActive && !isAB) || (variant.isPickUpOfferActive && (isAB || variant.additionalPickup));
    const lieferant = product?.lieferantenContact && product?.lieferantenContact.length > 0 ? product?.lieferantenContact[0] : false
    const herstellerangaben = variant?.herstellerangaben ? variant?.herstellerangaben : null;

    const handleQuantityInputChange = (newValue) => {
        setQuantityValue(newValue);
    };

    const handleAddToCart = (buttonType) => {
        if (!_.isNil(variant.stock) && variant.stock < quantityValue) {
            window.UIkit.notification(`Maximale Bestellmenge: ${variant.stock}`, {
                status: 'danger',
                pos: 'top-right',
            });
            return
        }
        trackEvent({
            category: 'E-Commerce',
            action: 'Lege-in-Warenkorb',
            label: variant.id || (product.shownId || product.id),
            value: getActiveSalesPrice(variant) * quantityValue * 100,
        });
        
        trackDataLayer({
            eventName:"add_to_cart", 
            products:[Object.assign(variant,{quantity: quantityValue})], 
            standort: markenStandort, 
            value: getActiveSalesPrice(variant) * quantityValue,
            isOnline: selectedQuantityBox.legalType === 'online-kauf'
        })

        trackPinterestEvent('addtocart', {
            action: 'Lege-in-Warenkorb',
            label: variant.id || (product.shownId || product.id),
            value: getActiveSalesPrice(variant) * quantityValue * 100,
            currency: 'EUR',
        });
        setSidebarVisible(true);
        dispatch(addProduct({ product: { ...variant, selectedLieferweg: selectedQuantityBox, deliveryDays: selectedQuantityBox.legalType === 'online-kauf' ? deliveryTime : pickupTime, deliveryText: selectedQuantityBox.legalType === 'online-kauf' ? `Lieferzeit: ${deliveryTime}` : `Abholbereit in: ${pickupTime}` }, quantity: quantityValue, buttonType }));
    }

    const isReservationProduct = (product?.additionalPickupLieferweg && product?.additionalPickupLieferweg?.legalType === "reservierung") || product.selectedLieferweg.legalType === "reservierung";
    const isNoa = markenStandort.gesellschafterNr === "035";
    
    return (
        <>
            <BreadCrumbSelector additionalCrumbs={additionalCrumbs} />
            <ProductDetailMeta variant={variant} soldOut={soldOut} pickup={product.additionalPickupLieferweg} shipping={product.selectedLieferweg} />
            <section className="uk-section uk-section-default uk-section-small">
                <div className="uk-container uk-margin-medium-top" data-uk-margin="">
                    {/* {soldOut && (
                        <div
                            className="uk-light uk-border-pill uk-padding-small uk-width-medium uk-text-center uk-text-bold uk-text-large"
                            style={{ background: 'var(--grey-light-main, #e0e0e0)', color: 'var(--font-main)'}}
                        >
                            In Kürze wieder lieferbar
                        </div>
                    )} */}
                    <div className="uk-grid uk-child-width-1-1 uk-child-width-1-2@s uk-child-width-1-2@m uk-first-column" data-uk-grid="">
                        <div className="product-images-container">
                            <ProductImages variant={variant} images={variant.images ?? []} isOfferActive={isOfferActive} />
                        </div>
                        <div className="product-info-container" ref={headline}>
                            <div className='uk-container'>
                                <h1 className='headline'>
                                    <span dangerouslySetInnerHTML={{ __html: variant.bezeichnung }} />
                                </h1>
                                <p>Artikelnummer: {variant.shownId || variant.id}</p>
                                <VariantSelector product={product} variantId={selectedVariantId} setVariantId={setVariantId} />
                                {/*  for lieferzeit */}
                                <div className="uk-flex uk-flex-between uk-flex-middle uk-padding-small uk-padding-remove-top uk-padding-remove-left uk-padding-remove-right">
                                    {selectedQuantityBox.legalType === 'online-kauf' && (
                                        variant.expressDelivery ? (
                                            <DeliveryCountdown
                                                expressDeliveryTimeISO={variant.expressDelivery}
                                            />
                                        ) : (
                                            !variant.soldOut && deliveryTime && (
                                                <div className="uk-flex uk-flex-middle">
                                                    <span className="uk-icon uk-icon-circle lieferzeit-icon-badge"></span>
                                                    <span
                                                        className="uk-text-small uk-margin-small-left"
                                                        id="lieferzeit-hinweis"
                                                    >
                                                        Lieferzeit {deliveryTime}
                                                    </span>
                                                </div>
                                            )
                                        )
                                    )}

                                    {!variant.soldOut && pickupTime && selectedQuantityBox.legalType === "reservierung" && (
                                        <>
                                            <div className="uk-flex uk-flex-middle">
                                                <span className="uk-icon uk-icon-circle lieferzeit-icon-badge"></span>
                                                <span
                                                    className="uk-text-small uk-margin-small-left"
                                                    id="abholbereit-hinweis"
                                                >
                                                    Abholbereit innerhalb von {pickupTime}
                                                </span>
                                            </div>
                                        </>
                                    )}
                                </div>
                            </div>
                            <div className="uk-child-width-1-1 uk-grid-small" data-uk-grid="">
                                {(!_.isNil(variant.vk_preis) || !_.isNil(variant.pickup_preis) || (!markenStandort.isTechno)) ? (
                                    <>
                                        <QuantityBox
                                            isBattery={isBattery}
                                            lieferweg={product.selectedLieferweg}
                                            variant={variant}
                                            isOfferActive={product.selectedLieferweg.legalType === 'online-kauf' ? variant.isDeliveryOfferActive : variant.isPickUpOfferActive}
                                            isSelected={selectedQuantityBox === product.selectedLieferweg}
                                            onSelect={() => setSelectedQuantityBox(product.selectedLieferweg)}
                                            quantity={quantityValue}
                                            isFreeShipping={isFreeShipping}
                                        />
                                        {(product.additionalPickupLieferweg && variant.additionalPickup) && (
                                            <QuantityBox
                                                isBattery={isBattery}
                                                lieferweg={product.additionalPickupLieferweg}
                                                variant={variant}
                                                isOfferActive={variant.isPickUpOfferActive}
                                                isSelected={selectedQuantityBox === product.additionalPickupLieferweg}
                                                onSelect={() => setSelectedQuantityBox(product.additionalPickupLieferweg)}
                                                quantity={quantityValue}
                                            />
                                        )}
                                    </>
                                ) : (
                                    !showMap && markenStandort.isTechno && (
                                        <LocationSelector
                                            onSubmit={({ zipCode }) => {
                                                setPlz(zipCode);
                                                setShowMap(true);
                                            }}
                                        />
                                    )
                                )}
                                <div className="uk-grid-small uk-child-width-1-1 uk-child-width-1-2@s uk-first-column uk-padding-remove-left uk-margin-remove-left" data-uk-grid="">
                                    <div>
                                        {selectedQuantityBox.abcKategorie === 'C' &&
                                            <div className="uk-form-controls">
                                                <QuantityInput
                                                    initialValue={1}
                                                    minValue={1}
                                                    maxValue={4}
                                                    onChange={handleQuantityInputChange}
                                                    ariaLabel="Menge festlegen. Minimum: 1, Maximum: 4"
                                                />
                                            </div>
                                        }
                                        {selectedQuantityBox.abcKategorie !== 'C' &&
                                            <div className="uk-form-controls">
                                                <QuantityInput
                                                    initialValue={1}
                                                    minValue={1}
                                                    maxValue={(!variant.stock || variant.stock > 999) ? 1000 : variant.stock}
                                                    onChange={handleQuantityInputChange}
                                                    ariaLabel={`Menge festlegen. Minimum: 1, Maximum: ${(!variant.stock || variant.stock > 999) ? 1000 : variant.stock}`}
                                                />
                                            </div>
                                        }
                                        {(selectedQuantityBox.abcKategorie === 'C') && (
                                            <div className="uk-text-small" style={{ color: 'var(--shop-main)', marginTop: '3px' }}>
                                                Max. Bestellmenge: 4
                                            </div>
                                        )}
                                        {(selectedQuantityBox.abcKategorie !== 'C' && variant.stockkeeping && variant.stock > 0) && (
                                            <div className="uk-text-small" style={{ color: 'var(--shop-main)', marginTop: '3px' }}>
                                                Max. Bestellmenge: {variant.stock}
                                            </div>
                                        )}
                                        {(selectedQuantityBox.legalType === 'online-kauf' && markenStandort?.paypalPayLaterMessages) && (
                                            <div className='uk-padding-small uk-padding-remove-left'>
                                                <PayPalMessages forceReRender={[variant,quantityValue]} amount={getActiveSalesPrice(variant) * quantityValue} currency='EUR' placement='product' />
                                            </div>                                        
                                        )}
                                    </div>
                                    <div>
                                        <Button
                                            className={classnames('custom-button-qualityBox uk-width-1-1 uk-margin-small-bottom uk-text-uppercase', { 'soldout-theme': soldOut })}
                                            type="button"
                                            disabled={soldOut ||variant.deleted}
                                            onClick={() => handleAddToCart(selectedQuantityBox.legalType === 'online-kauf' ? 'addToCart' : 'reserve')}
                                            ariaLabel={selectedQuantityBox.legalType === 'online-kauf' ? 'Zum Warenkorb hinzufügen' : 'RESERVIEREN & ABHOLEN'}
                                            ariaDescribedBy={selectedQuantityBox.legalType === 'online-kauf' ? 'lieferzeit-hinweis' : 'abholbereit-hinweis'}
                                        >
                                            {selectedQuantityBox.legalType === 'online-kauf' ? 'Zum Warenkorb hinzufügen' : 'RESERVIEREN & ABHOLEN'}
                                        </Button>
                                        {selectedQuantityBox.legalType === 'online-kauf' && 
                                            <PayPalButtons 
                                                onClick={onClick}
                                                createOrder={createOrder}
                                                onApprove={approveOrder}
                                                onCancel={onCancel}
                                                onError={onError}
                                                fundingSource='paypal'
                                                style={ {
                                                    tagline: false,
                                                    shape: 'sharp',
                                                    label: 'checkout',
                                                    height: 44,
                                                }} 
                                            />
                                        }
                                    </div>
                                </div>
                                {/* Variant and for reifen articles */}

                                {variant.articleType === 'reifen' && (
                                    <div className='energy-label-box'>
                                        <div className="energy-label-header">
                                            <div className='energy-label-title uk-text-bold uk-text-large'>EU-Reifenlabel-Werte</div>
                                            <TireInformationModal tire={variant} adjusted={false} />
                                        </div>
                                        <div data-uk-grid="" className="uk-grid-small uk-child-width-expand@s">
                                            <TireEnergyLabelLinks tire={variant} />
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                    {herstellerangaben &&
                        <div className='uk-margin-large-bottom'>
                            <span><strong>Herstellerangaben:</strong> </span>
                            <span>
                                {herstellerangaben?.firma ? `${herstellerangaben?.firma} | ` : ""}
                                {herstellerangaben?.street ? `${herstellerangaben?.street} | ` : ""}
                                {herstellerangaben?.city || herstellerangaben.zipCode ? `${herstellerangaben?.zipCode ?? ''} ${herstellerangaben?.city ?? ''} | ` : ""}
                                {herstellerangaben?.phone ? `Tel: ${herstellerangaben.phone} | ` : ""}
                                {herstellerangaben?.email ? <>E-Mail: <ExternalLink to={`mailto:${herstellerangaben.email}`}>{herstellerangaben.email}</ExternalLink> | </> : ""}
                                {herstellerangaben?.homepage ? <>Webseite: <ExternalLink to={`${herstellerangaben.homepage}`}>{herstellerangaben.homepage}</ExternalLink> </> : ""}
                            </span>
                        </div>
                    }

                    {lieferant &&
                        <div className='uk-margin-large-bottom'>
                            <span><strong>Herstellerangaben:</strong></span><br />
                            <span>
                                {lieferant?.name ? `${lieferant?.name} | ` : ""}
                                {lieferant?.street ? `${lieferant?.street} | ` : ""}
                                {lieferant?.city && lieferant.zipCode ? `${lieferant?.zipCode} ${lieferant?.city} | ` : ""}
                                {lieferant?.phone ? `Tel: ${lieferant.phone} | ` : ""}
                                {lieferant?.fax ? `Fax: ${lieferant.fax} | ` : ""}
                                {lieferant?.email ? <>E-Mail: <ExternalLink to={`mailto:${lieferant.email}`}>{lieferant.email}</ExternalLink> | </> : ""}
                                {lieferant?.homepage ? `Webseite: ${lieferant.homepage}` : ""}
                            </span>
                        </div>
                    }

                    {
                        variant.marketingText &&
                        variant.marketingText !== "" &&
                        variant.marketingText !== "undefined" && (
                            <div>
                                <div
                                    dangerouslySetInnerHTML={{
                                        __html: variant.marketingText,
                                    }}
                                />
                            </div>
                        )}
                    {variant.dangerousGoodDescription && (
                        <div>
                            <div
                                dangerouslySetInnerHTML={{
                                    __html: variant.dangerousGoodDescription,
                                }}
                            />
                        </div>
                    )}
                    {variant.sicherHeitsDatenblatt && (
                        <div className="uk-width-1-1 uk-text-large uk-text-right">
                            <ExternalLink to={`https://www.tibsonline.de/AddvMultimedia/${variant.sicherHeitsDatenblatt}`}>
                                <i className="fa fa-file-pdf-o uk-margin-small-right" />
                                Sicherheitsdatenblatt
                            </ExternalLink>
                        </div>
                    )}
                    {variant.verwendungsHinweis && (
                        <div className="uk-width-1-1 uk-text-large uk-text-right">
                            <ExternalLink to={`https://www.tibsonline.de/AddvMultimedia/${variant.verwendungsHinweis}`}>
                                <i className="fa fa-file-pdf-o uk-margin-small-right" />
                                Verwendungshinweis
                            </ExternalLink>
                        </div>
                    )}
                    {/* {isOil && (
                        <div className="uk-width-1-1 uk-text-large uk-text-right">
                            <InternalLink to="/altoelHinweis" newTab>
                                <i className="fa fa-file-text-o uk-margin-small-right" />
                                Hinweis zur Entsorgung von Altöl
                            </InternalLink>
                        </div>
                    )}
                    {isBattery && (
                        <div className="uk-width-1-1 uk-text-large uk-text-right">
                            <ExternalLink to="https://techno-images.s3.eu-central-1.amazonaws.com/pdfs/EntsorgungBatterie2.pdf">
                                <i className="fa fa-file-pdf-o uk-margin-small-right" />
                                Hinweis zur Batterieentsorgung
                            </ExternalLink>
                        </div>
                    )} */}
                    {variant.articleType === 'batterie' && (
                        <div className="uk-width-1-1 uk-text-small uk-background-muted uk-padding-small uk-margin-medium-top">
                            {textBatterie && <div className="seitentext-content" dangerouslySetInnerHTML={{ __html: textBatterie.text }} />}
                        </div>
                    )}
                    {variant.articleType === 'öl' && (
                        <div className="uk-width-1-1 uk-text-small uk-background-muted uk-padding-small uk-margin-medium-top">
                            {textAltöl && <div className="seitentext-content" dangerouslySetInnerHTML={{ __html: textAltöl.text }} />}
                            <p>
                                <strong>
                                    {`${markenStandort.anschrift.firma} | ${markenStandort.anschrift.strasse} | ${markenStandort.anschrift.plz} ${markenStandort.anschrift.ort}`}
                                </strong>{' '}
                                <br />
                                <br />
                                Sie können das Altöl dort jederzeit kostenlos während unserer Öffnungszeiten: <br />
                                <br /> <strong>{markenStandort.oeffnungszeiten}</strong> abgeben. <br /> <br />
                                Es besteht auch die Möglichkeit, das Altöl an uns zurückzusenden. Bitte beachten Sie,
                                dass für das Versenden besondere Transportbedingungen, insbesondere die Bestimmungen zum
                                Gefahrgut gelten können; bitte holen Sie vor der Versendung entsprechende Informationen ein.
                                Nehmen Sie auch zur Kenntnis, dass wir die Kosten der Rücksendung von Altöl nicht übernehmen.
                                Unsere Annahmestelle verfügt über eine Einrichtung, die es ermöglicht, den Ölwechsel fachgerecht durchzuführen.
                            </p>
                        </div>
                    )}
                    {variant.documents?.length > 0 && (
                        <ul className="uk-list">
                            {variant.documents
                                .filter(document => !_.isString(document))
                                .map(({ url, description }, i) => {
                                    return (
                                        <li key={i}>
                                            <ExternalLink to={url} modifier="reset" ariaLabel="PDF herunterladen und öffnen">
                                                <i className="fa fa-file-pdf-o uk-margin-small-right" />
                                                {description}
                                            </ExternalLink>
                                        </li>
                                    );
                                })}
                        </ul>
                    )}
                    {/* {vorteile.length > 0 && (
                        <div className="uk-background-muted uk-padding">
                            <div className="uk-flex uk-flex-wrap uk-flex-center@m">
                                {vorteile.map((vorteil, i) => (
                                    <div className="uk-flex uk-flex-middle uk-margin-small-right uk-width-1-1 uk-width-auto@m" key={i}>
                                        <i className="fa fa-check uk-margin-small-right uk-font-main" />
                                        {vorteil?.text ? vorteil?.text : vorteil}
                                    </div>
                                ))}
                            </div>
                        </div>
                    )} */}
                    <div ref={serviceStationFinderRef} className="serviceStationFinderRef">
                        {showMap && (
                            <ServiceStationFinder
                                prefilledZip={plz}
                                categoryUrl={categoryUrl}
                                redirectUrl={`/${categoryUrl}/${variant.slug || variant.id || variant._id}`}
                                productVariantId={variant._id}
                            />
                        )}
                    </div>
                    {/* {isBattery && (
                        <div>
                            * Im Zusammenhang mit dem Vertrieb von Fahrzeugbatterien sind wir gemäß § 10 BattGh verpflichtet, je
                            Fahrzeugbatterie ein Pfand in Höhe von 7,50 Euro einschließlich Umsatzsteuer zu erheben. Dies entfällt, wenn Sie
                            beim Kauf Ihre gebrauchte Batterie bei uns entsorgen.
                        </div>
                    )} */}
                </div>
            </section>
            {(standortUrl === "gottfried-schultz") && (
                <section className="uk-section uk-section-default uk-section-small">
                    <div className="uk-container" data-uk-margin="">
                        <df-recommendations
                            hashid="620d82bb1f2780b7e65724b6536633bb"
                            total-products="10"
                        ></df-recommendations>
                    </div>
                </section>
            )}
            <FAQs />
            <MoreProducts productID={variant.shownId || variant.id}/>
            <div id='locations-for-product'>
                <SubLocationFinder forProductDetail={true} />
            </div>
            {/* {!markenStandort.isTechno && <DealerInfo />} */}
            <section className="uk-section uk-section-muted uk-section-small">
                <div className="uk-container uk-container-xsmall">
                    <Meisterkachel />
                </div>
            </section>
            <Offcanvas overlay isVisible={isSidebarVisible} onIsVisibleChange={visible => setSidebarVisible(visible)} flip={true} className="side-bar-zindex">
                <div className="uk-offcanvas-bar product-sidebar" style={{ top: offsetTop, bottom: 0, overflowY: 'auto', WebkitOverflowScrolling: 'touch', paddingBottom: 'env(safe-area-inset-bottom, 16px)' }}>
                    <button className="uk-offcanvas-close focus" type="button" ref={focusBtnRef} data-uk-close="" onKeyPress={handlePress} onClick={closeSidebar} aria-label='Navigation schließen' aria-hidden="true" focusable="false" />
                    <span className='uk-text-bold menu-black'><i className="fa fa-check-circle" aria-hidden="true" style={{ color: "#128001" }} /> <span className='uk-margin-small-left'> Artikel wurde hinzugefügt</span></span>
                    <div className='uk-flex uk-flex-middle uk-margin-top'>
                        <div className='uk-margin-small-right'>
                            <Image src={variant.images[0]} alt={variant.bezeichnung} resizeHeight={120} fit="cover" />
                        </div>
                        <div className='uk-margin-small-left'>
                            <p className='headline headline-sidebar'>
                                <span dangerouslySetInnerHTML={{ __html: variant.bezeichnung }} />
                            </p>

                            {((!isReservationProduct && !variant.isOwnArticle ? !variant.aktionsPreis : isReservationProduct && variant.isOwnArticle ? !variant.aktionsPreisPickup : !variant.aktionsPreis) || !isOfferActive) ? (
                                <span className="aps-price sidebar-price">
                                    {selectedQuantityBox.legalType === "reservierung" && variant.isOwnArticle ? (
                                        <>
                                            {!variant.pickup_preis ? (
                                                <Currency quantity={variant.vk_preis * quantityValue} />
                                            ) : (
                                                <Currency quantity={variant.pickup_preis * quantityValue} />
                                            )}
                                        </>
                                    ) : (
                                        <Currency quantity={variant.vk_preis * quantityValue} />
                                    )}
                                </span>
                            ) : (((variant.aktionsPreis && variant.aktionsPreis >= variant.vk_preis) &&
                                (variant.aktionsPreisPickup && variant.aktionsPreisPickup >= variant.pickup_preis)) ? (
                                <div className="uk-text-center">
                                    <span className={classnames('aps-price sidebar-price', { 'noaPrice': isNoa })}>
                                        {selectedQuantityBox.legalType === "reservierung" && variant.isOwnArticle ? (
                                            <>
                                                {!variant.pickup_preis ? (
                                                    <Currency quantity={variant.vk_preis * quantityValue} />
                                                ) : (
                                                    <Currency quantity={variant.pickup_preis * quantityValue} />
                                                )}
                                            </>
                                        ) : (
                                            <Currency quantity={variant.vk_preis * quantityValue} />
                                        )}
                                    </span>
                                </div>
                            ) : (
                                <>
                                    <div className="uk-width-auto uk-flex uk-flex-column uk-width-expand">
                                        <div className={classnames(isNoa ? "uk-flex noaOldPrice" : "uk-flex uk-flex-column")}>
                                            <div className="uk-h6 aps-price-old uk-margin-remove-top uk-margin-remove-bottom">
                                                <span className="statt">statt </span>
                                                {selectedQuantityBox.legalType === "reservierung" && variant.isOwnArticle ? (
                                                    <span>
                                                        {!variant.pickup_preis ? (
                                                            <Currency quantity={variant.vk_preis * quantityValue} />
                                                        ) : (
                                                            <Currency quantity={variant.pickup_preis * quantityValue} />
                                                        )}
                                                    </span>
                                                ) : (
                                                    <span><Currency quantity={variant.vk_preis * quantityValue} /></span>
                                                )}
                                            </div>
                                            <span className={classnames('aps-price sidebar-price uk-text-offer uk-margin-remove-top uk-margin-remove-bottom uk-flex', { 'noaPrice': isNoa })}>
                                                {!isNoa && <span className='percentage uk-flex' aria-label='rabattierter Artikel'>%</span>}
                                                {selectedQuantityBox.legalType === "reservierung" && variant.isOwnArticle ? (
                                                    <>
                                                        {!variant.aktionsPreisPickup ? (
                                                            <Currency quantity={variant.aktionsPreis * quantityValue} />
                                                        ) : (
                                                            <Currency quantity={variant.aktionsPreisPickup * quantityValue} />
                                                        )}
                                                    </>
                                                ) : (
                                                    <Currency quantity={variant.aktionsPreis * quantityValue} />
                                                )}
                                            </span>
                                        </div>
                                    </div>
                                </>
                            )
                            )}
                        </div>
                    </div>
                    <hr />
                    <ReduxSuspense response={topSellerResponse} error={null} fallback={<InlineSpinner />}>
                        {data => {
                            if (_.isEmpty(data?.data)) return null;
                            return (
                                <section className="uk-section-default uk-padding-remove-bottom">
                                    <div className="uk-container uk-margin-medium-top">
                                        <p className='menu-black'><span>Jetzt gleich mitbestellen</span></p>
                                        <MoreProductsSlider>
                                            {data.data.map(product => (
                                                <li key={product.id}>
                                                    <MoreProductsSliderCard product={product} onClose={closeSidebar} />
                                                </li>
                                            ))}
                                        </MoreProductsSlider>
                                    </div>
                                </section>
                            );
                        }}
                    </ReduxSuspense>
                    <div className="uk-flex uk-flex-column uk-text-center uk-text-right@s uk-width-expand uk-padding-small uk-margin-top-small">
                        <Button
                            className={classnames('custom-button-qualityBox-default uk-text-uppercase')}
                            type="button"
                            modifier="default"
                            onClick={() => closeSidebar()}
                            ariaLabel='WEITER EINKAUFEN'
                        >
                            WEITER EINKAUFEN
                        </Button>

                        <InternalLink to="/warenkorb" fullWidth className="uk-margin-top uk-button uk-button-primary custom-button-qualityBox uk-text-uppercase" modifier="primary" ariaLabel="ZUM WARENKORB">
                            ZUM WARENKORB
                        </InternalLink>
                    </div>
                </div>
            </Offcanvas>
        </>
    );
}

function LoadProductDetail({ categoryUrl, productUrl, productResponse, isExact }) {
    const markenStandort = useSelector(markenStandortSelector);
    const redirectsResponse = useSelector(redirectsResponseSelector);
    const location = useLocation();
    const redirects = useSelector(redirectsSelector);
    let url = `/${markenStandort.url}`;
    if (markenStandort.url !== 'de') {
        url = '';
    }

    // Redirect /exakt URLs to non-exakt equivalent (301)
    if (location.pathname.endsWith('/exakt')) {
        const newPath = location.pathname.replace(/\/exakt$/, '');
        return <Redirect to={newPath} />;
    }

    if (productResponse.status === "FAILURE") {
        if(markenStandort.url === "estore-rkg"){
            return <NotFound />
        }
        if (redirectsResponse.status !== "SUCCESS") {
            return null;
        }
        const match = findRedirectMatch(redirects, location);
        if (match) {
            return <RedirectCheck />;
        }
        return <Redirect to={`${url}/${categoryUrl}`} />;
    }

    if (productResponse.status === "SUCCESS" && productResponse.data?.slug) {
        const expectedPath = `${url}/${categoryUrl}/${productResponse.data.slug}`;

        if (location.pathname !== expectedPath) {
            return <Redirect to={expectedPath} />;
        }
    }

    return (
        <ReduxSuspense
            response={productResponse}
            fallback={
                <>
                    <BreadCrumbSelector />
                    <Spinner />
                </>
            }
        >
            {product => <ProductDetail product={product} categoryUrl={categoryUrl} productUrl={productUrl} isExact={isExact} />}
        </ReduxSuspense>
    );
}

const frontload = async ({ fetchProductIfNeeded, productUrl, categoryUrl, isExact }) => {
    await fetchProductIfNeeded({ productUrl, categoryUrl, isExact });
};

const mapStateToProps = (state, { match }) => {
    const { categoryUrl, productUrl, exakt } = match.params;
    return {
        productResponse: productResponseSelector(state, { productUrl, categoryUrl }),
        isExact: exakt === 'exakt',
        categoryUrl,
        productUrl,
    };
};

const mapDispatchToProps = { fetchProductIfNeeded, addProduct };

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withStandortRouter(frontloadConnect(frontload, { onUpdate: true })(LoadProductDetail)));
